<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'VehicleMileage',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        fixed: true,
        width: 25,
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
        groupIndex: 1,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'End',
        caption: 'Конец',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 150,
      }, {
        dataField: 'Duration',
        caption: 'Длительность',
        alignment: 'center',
        width: 90,
      }, {
        dataField: 'MaxSpeed',
        caption: 'Макс. скорость',
        alignment: 'center',
        width: 100,
      }, {
        dataField: 'RidesCount',
        caption: 'Кол-во поездок',
        alignment: 'center',
        width: 95,
      }, {
        dataField: 'MileageKm',
        caption: 'Пробег, км',
        width: 75,
      }, {
        dataField: 'CityMileageKm',
        caption: 'Городской пробег, км',
        width: 90,
      }, {
        dataField: 'CountryMileageKm',
        caption: 'Загородный пробег, км',
        width: 100,
      }, {
        dataField: 'BeginLocation',
        caption: 'Начальное положение',
      }, {
        dataField: 'EndLocation',
        caption: 'Конечное положение',
      }],
      summaryColoumn: [{
        column: 'Duration',
        name: 'Duration',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'MaxSpeed',
        name: 'MaxSpeed',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'RidesCount',
        name: 'RidesCount',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'MileageKm',
        name: 'MileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'CityMileageKm',
        name: 'CityMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'CountryMileageKm',
        name: 'CountryMileageKm',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'BeginLocation',
        name: 'BeginLocation',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EndLocation',
        name: 'EndLocation',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      index: 0,
      indexRow: 0,
    };
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      this.convertData(this.reportData);
      this.getSummary();
      this.getAddresses();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    this.convertData(this.reportData);
    this.getSummary();
    this.getAddresses();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  methods: {
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }
        if (item.column.dataField === 'Begin' || item.column.dataField === 'BeginLocation') {
          const value = {
            lat: item.data.BeginLocationLatitude,
            lng: item.data.BeginLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
        if (item.column.dataField === 'End' || item.column.dataField === 'EndLocation') {
          const value = {
            lat: item.data.EndLocationLatitude,
            lng: item.data.EndLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },

    convertData (data) {
      if (this.reportData.IsSummary) {
        let rows = [];
        data.Data.Data.forEach((items) => {
          items.Rows.forEach((_row, i) => {
            const row = _row;
            row.RowNum = i + 1;
            row.ObjectName = items.ObjectName;
            // rows.push(row);

            row.Group = i;
            row.Begin = row.Date;
            row.End = null;
            row.MileageKm = row.SumMileageKm;
            row.CountryMileageKm = row.SumCountryMileageKm;
            row.CityMileageKm = row.SumCityMileageKm;

            row.Rows.forEach((_item, j) => {
              const item = _item;
              item.ObjectName = items.ObjectName;
              item.Group = i;
              item.RowNum = j + 1;
              item.RidesCount = 1;
              item.Date = row.Date;
            });
            rows = rows.concat(row.Rows);
          });
        });
        this.reportSummary = rows;
      } else {
        let rows = [];
        data.Data.Data.Rows.forEach((_group, i) => {
          const group = _group;
          group.Group = i;
          group.RowNum = i + 1;
          group.Begin = group.Date;
          group.End = null;
          group.MileageKm = group.SumMileageKm;
          group.CountryMileageKm = group.SumCountryMileageKm;
          group.CityMileageKm = group.SumCityMileageKm;

          group.Rows.forEach((_item, j) => {
            const item = _item;
            item.Group = i;
            item.RowNum = j + 1;
            item.RidesCount = 1;
            item.Date = group.Date;
          });
          rows = rows.concat(group.Rows);
        });
        this.reportSummary = rows;
      }
    },
    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              if (!this.reportData.Data.Data.Rows[this.index]) {
                this.index = 0;
              }
              const value = options;
              const totalValue = this.reportData.Data.Data.Rows[this.index][options.name];
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
              if (options.name === 'EndLocation') {
                this.index += 1;
              }
            }
          },
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              const value = options;
              const data = this.reportData.Data.Data.filter(arr => arr.Rows.length > 0);
              if (!data[this.index]) {
                this.index = 0;
                this.indexRow = 0;
              }
              if (options.groupIndex === 1) {
                if (data[this.index] && !data[this.index].Rows[this.indexRow]) {
                  this.indexRow = 0;
                }
                value.totalValue = data[this.index] && data[this.index].Rows[this.indexRow] ? data[this.index].Rows[this.indexRow][`${options.name}`] : undefined;
                if (options.name === 'EndLocation') {
                  this.indexRow += 1;
                  if (!data[this.index].Rows[this.indexRow]) {
                    this.index += 1;
                    this.indexRow = 0;
                  }
                }
              }
            }
          },
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },

    getAddresses () {
      if (this.reportData.State === 'Done' || this.reportData.State === 'OK') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
            this.getAddress(row.EndLocationLatitude, row.EndLocationLongitude, row, false);
            row.Rows.forEach((rows) => {
              this.getAddress(rows.BeginLocationLatitude, rows.BeginLocationLongitude, rows, true);
              this.getAddress(rows.EndLocationLatitude, rows.EndLocationLongitude, rows, false);
            });
          });
        } else {
          this.reportData.Data.Data.forEach((obj) => {
            obj.Rows.forEach((row) => {
              this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
              this.getAddress(row.EndLocationLatitude, row.EndLocationLongitude, row, false);
              row.Rows.forEach((rows) => {
                this.getAddress(rows.BeginLocationLatitude, rows.BeginLocationLongitude, rows, true);
                this.getAddress(rows.EndLocationLatitude, rows.EndLocationLongitude, rows, false);
              });
            });
          });
        }
      }
    },
    getAddress (lat, lon, _row, begin) {
      const row = _row;
      const location = begin ? 'BeginLocation' : 'EndLocation';
      row[location] = null;
      setImmediate(async () => {
        const address = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
        row[location] = address;
      });
    },
  },
};
</script>
